import { render, staticRenderFns } from "./ListOf.vue?vue&type=template&id=6be80ca4"
import script from "./ListOf.vue?vue&type=script&lang=js"
export * from "./ListOf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports